export type RenderHooks = {
  onPageChange: () => void;
  onStateChange: () => void;
  onLayerChange: () => void;
  onFrameChange: () => void;
  cancelSelectionMenu: () => void;
  onSelectionChangeCallback: () => void;
  onClientConfigChange: (config: Record<string, unknown>) => void;
  onReadClientConfigChange: () => void | Record<string, unknown>;
};

// FIXME: find a better way to replace those hooks
export function createProxiedHoos(hooks: RenderHooks) {
  const originHooks: RenderHooks = {
    ...hooks,
  };

  return new Proxy(hooks, {
    set: (target, prop, customHook) => {
      const originHook = originHooks[prop];
      const val = originHook
        ? (...args) => {
            originHook(...args);
            return customHook(...args);
          }
        : customHook;
      Reflect.set(target, prop, val);
      return true;
    },
  });
}
